import {
    IImage,
    IImageData, IImageSimple,
    IMAGE_NAME_MAX_LENGTH
} from './index'
import {IPoint, IPointData} from "@/entities";

export class Image implements IImage {
    readonly id?: number
    name?: string
    readonly file: string

    constructor(data?: IImageData) {
        this.id = data?.id
        this.update(data)
        this.file = data?.file || ''
    }

    validate(): boolean {
        return (this.validateName())
    }

    update(data?: IImageData): void {
        this.name = data?.name || this.name;
    }

    private validateName(): boolean {
        let name = this.name
        return !!name && name.length <= IMAGE_NAME_MAX_LENGTH
    }
}

export class ImageSimple implements IImageSimple {
    readonly url?: string
    alt?: string

    constructor(data?: IImageData) {
        this.url = data?.file
        this.alt = data?.name
    }
}
